export default __webpack_public_path__ + "static/media/radio-medium.6a6c102c.jpg";